import React from "react";
import PropTypes from "prop-types";
import { uniqBy } from "lodash";

import { Dropdown } from "..";

export function FieldTypeSelector({ types, initialValue, onChange, ...props }) {
  const getDropdownOptions = () => {
    const options = types.map(({ id, text }) => {
      return { key: id, value: id, text: text };
    });

    return initialValue
      ? uniqBy(
          options.concat({
            key: initialValue.id,
            value: initialValue.id,
            text: initialValue.text,
          }),
          "key"
        )
      : options;
  };

  return (
    <Dropdown
      fluid
      search
      selection
      placeholder="Select field type"
      data-test="type-dropdown"
      {...props}
      options={getDropdownOptions()}
      defaultValue={initialValue?.id}
      onChange={(_, { value }) => {
        onChange(
          types.find(({ id }) => {
            return id === value;
          })
        );
      }}
    />
  );
}

FieldTypeSelector.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      showOptions: PropTypes.bool,
    })
  ),
  initialValue: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    showOptions: PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
};

FieldTypeSelector.defaultProps = {
  initialValue: null,
  types: [],
};

export default FieldTypeSelector;
